import { InputAdornment, TextField } from '@mui/material';
import customAxios from '../../../utils/customAxios';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { GlobalVariables } from '../../../globalVar';
import '../../../scss/Components/_modal.scss';
import { getToast } from '../../../utils/toastConfig';

function ModalVT(props) {
  const {
    vTypesModalCreateString,
    vTypesMCVtypeString,
    vTypesMCDescString,
		vTypesMCEstimatedTimeString,
    saveString,
  } = useTranslationHook();

  const [vtName, setVTName] = useState('');
  const [description, setDescription] = useState('');
  const [estimatedDuration, setEstimatedDuration] = useState(1);

  function createVisitType(event) {
    event.preventDefault();
    customAxios
      .post(`${GlobalVariables.getURL()}createVisitType`, {
        // url to POST
        vt_name: vtName,
        description: description,
				estimatedDuration: estimatedDuration
      }, {
        headers: {
          'Authorization': 'bearer ' + localStorage.getItem('token')
        }
      })
      .then(
        (response) => {
          console.log(response);
          hide();
          // successAlert();
        },
        (error) => {
          console.log(error);
          getToast({ status: 'error', title: 'Error al crear tipo de servicio. Vuelve a intentarlo.' });
        }
      );
  }

  function hide() {
    props.onHide();
    getToast({ status: 'success', title: 'Tipo de servicio creado exitosamente en la base de datos.' });
    props.getVisitTypesData();
  }

  return (
    <Modal
      {...props}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'>
          {vTypesModalCreateString}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form id='add-vt-form' onSubmit={createVisitType}>
          <div className='row'>
            <div className='col-md-12'>
              <TextField
                sx={{ width: '100%' }}
                label={vTypesMCVtypeString}
                type='text'
                value={vtName}
                onChange={(e) => setVTName(e.target.value)}
                required
              />
            </div>
          </div>

          <br />

          <div className='row'>
            <div className='col-md-12'>
							<TextField
                sx={{ width: '100%' }}
                label={vTypesMCEstimatedTimeString}
                type='number'
                value={estimatedDuration}
                onChange={(e) => setEstimatedDuration(e.target.value)}
								InputProps={{
									endAdornment: <InputAdornment position='end'>hrs</InputAdornment>
								}}
								ad
                required
              />
            </div>
          </div>

          <br />

          <div className='row'>
            <div className='col-md-12'>
              <TextField
                multiline
                sx={{ width: '100%' }}
                label={vTypesMCDescString}
                rows={4.5}
                type='text'
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
              />
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button form='add-vt-form' type='submit' className='save-modal-button'>
          {saveString}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalVT;
